import ACTION_TYPES from "../actions/actionTypes";

export default (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.FETCH_SITE_LIST:
      return { ...state, siteData: action.payload };
    case ACTION_TYPES.GET_PEOPLE_DATA:
      return { ...state, peopleData: action.payload };
    case ACTION_TYPES.FETCH_REASON_CODE_LIST:
      return { ...state, reasonCodeData: action.payload };
    case ACTION_TYPES.FETCH_VIZUALIZATION:
      return { ...state, vizualizationData: action.payload };
    case ACTION_TYPES.FETCH_TIER_LIST:
      return { ...state, tiersData: action.payload };
    case ACTION_TYPES.FETCH_ABOVE_TIER_LIST:
      return { ...state, tiersAboveData: action.payload };
    case ACTION_TYPES.FETCH_GEMBA_TYPES:
      return { ...state, gembaTypes: action.payload };
    case ACTION_TYPES.FETCH_CALENDAR_EVENT_TYPES:
      return { ...state, calendarEventTypes: action.payload };
    case ACTION_TYPES.FETCH_INCIDENT_TYPE_LIST:
      return { ...state, incidentTypeData: action.payload };
    case ACTION_TYPES.FETCH_SITE_LISTS:
      return { ...state, siteData: action.payload };
    case ACTION_TYPES.GET_USER_DETAILS:
      return { ...state, userDetails: action.payload };
    case ACTION_TYPES.GET_PINNED_MAIL:
      return { ...state, pinnedMailDetails: action.payload };
    case ACTION_TYPES.GET_USER_MAIL:
      return { ...state, userMailDetails: action.payload };
    case ACTION_TYPES.FETCH_OPH_MISS_REASON_CODES:
      return { ...state, ophMissReasonCodes: action.payload };
    case ACTION_TYPES.FETCH_HSE:
      return { ...state, tasks: action.payload };
    case ACTION_TYPES.FETCH_SHIFT_LIST: {
      let response = action.payload;
      response.shifts = JSON.parse(response.shifts);
      return { ...state, shiftDetails: response };
    }
    case ACTION_TYPES.GET_USER_DATA:
      return { ...state, userDetails: action.payload };
    case ACTION_TYPES.GET_USER_DATA_ACCESS:
      return { ...state, userDetailsAppaccess: action.payload };
    case ACTION_TYPES.FETCH_REASON_CODE_LIST_FORADMIN:
      return { ...state, reasonCodeDataAdmin: action.payload };
    case ACTION_TYPES.GET_LID_PLANT_DATA:
      return { ...state, LIDPlantData: action.payload };

    case ACTION_TYPES.GET_USER_DATA_ACCESS:
      return { ...state, userDetailsAppaccess: action.payload };
    case ACTION_TYPES.FETCH_SMESS_REASON_CODE_LIST_FORADMIN:
      return { ...state, smessReasonCodeDataAdmin: action.payload };
    case ACTION_TYPES.FETCH_LINES_LIST:
      return { ...state, LinesData: action.payload };
    case ACTION_TYPES.FETCH_MATERIAL_LIST:
      return { ...state, MatirialsData: action.payload };
    case "FETCH_MAT_SHIFT_LIST":
      return { ...state, shiftDetails: action.payload };
    case ACTION_TYPES.GET_TIMEZONE_LIST:
      return { ...state, TimezoneData: action.payload };
    case "SAVE_MAT_SHIFT_ERR":
      return { ...state, errorInfo: action.payload };
    case "FETCH_MAT_SHIFTS_LIST_DATA":
      return { ...state, shiftListData: action.payload };
    case "FETCH_MAT_SHIFT_DELETE":
      return { ...state, shiftDeleteInfo: action.payload };
    case "SITE_TIME_INFO":
      return { ...state, siteInfo: action.payload };
    case ACTION_TYPES.FETCH_BULK_MATERIAL_LIST:
      return { ...state, CountData: action.payload };
    case ACTION_TYPES.FETCH_SCHEDULED_REPORT:
      return { ...state, scheduleReportData: action.payload };
    case ACTION_TYPES.FETCH_SCHEDULED_REPORT_LIST_DATA:
      return { ...state, ScheduleReportTierListData: action.payload };
    case ACTION_TYPES.FETCH_SETTINGS_MULTI_SURVEY_DATA:
      return { ...state, multiSurveyGridData: action.payload };
    case ACTION_TYPES.FETCH_SETTINGS_MULTI_SURVEY_TIERS_DATA:
      return { ...state, multiSurveyTierGridDatas: action.payload };
    case ACTION_TYPES.FETCH_QUESTIONARE_DATA:
      return { ...state, surveyData: action.payload };
    case "REASON_CODE_TIERS":
      return { ...state, reasonsTier: action.payload };
    case "LEVEL_0_LIST":
      return { ...state, level0List: action.payload };
    case "USER_PREF_SETTINGS":
      return { ...state, userPrefSettings: action.payload };
    case "REASON_CODES_IMPORT":
      return { ...state, importReasonsRes: action.payload };

    case ACTION_TYPES.GET_LANGUAGES_BY_REGION:
      return {
        ...state,
        languagesByRegion: action.payload,
      };
    case ACTION_TYPES.GET_INPUT_TYPE_REASON_CODE_BY_LANG_ID:
      return {
        ...state,
        inputTypeReasonCodeByLangId: action.payload,
      };
    case ACTION_TYPES.SEND_TOAST_MESSAGE:
      return {
        ...state,
        toastData: action.payload,
      };
    case ACTION_TYPES.FETCH_LANGUAGE:
      return { ...state, LanguageData: action.payload };
    default:
      return state;
  }
};
